import React, { useEffect, useState } from 'react'
import { Cargando } from '../../components/Otros/Cargando'
import { Dimmer, Loader } from 'semantic-ui-react'
import { selectUser } from "../../reducers/userSlice";
import { useSelector } from "react-redux";
import { validarEvaluacion } from '../../utils/Datos';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
export const SuccessCu = () => {

    const [cargando, setcargando] = useState(true)
    const [error, seterror] = useState(false)
    const params = Object.fromEntries(new URLSearchParams(window.location.search));
    const user = useSelector(selectUser);
    const rut = user.user.run;
    const navigate = useNavigate();
    

    useEffect(() => {
        console.log(params);
        if (params.run==rut) {
            console.log('RUT ES CORRECTO',rut,params.run);
            if (params.param==null) {
                setcargando(false);
                seterror(true);
            }else{
                const id_precalifiacion=params.param.split(';')[1];
                const acuerdo=params.param.split(';')[2];
                console.log('la precalificación es',id_precalifiacion,acuerdo);
                validarEvaluacion({
                          id_preQualifications: id_precalifiacion,
                          statementOfFunMeeting: true,
                          isThisAgreement: acuerdo,
                        }).then((respuesta) => {
                          if (respuesta.status) {
                            Swal.fire({
                              title: "Autorizado",
                              text: "Evaluación validada con éxito",
                              icon: "success",
                              confirmButtonText: "Ok",
                            }).then(function () {
                              navigate("/misEvaluaciones");
                            });
                            //Redirect ?
                          } else {
                            Swal.fire({
                              title: "No autorizado",
                              text: respuesta.errores ?? "Ocurrió un error",
                              icon: "error",
                              confirmButtonText: "Ok",
                            }).then(function () {
                              seterror(true);
                            });
                          }
                          setcargando(false);
                });
            }
            

        }else{
            console.log('RUT ES INCORRECTO');
        }
    }, [])
    
  return (
    <div className="row">
        <div className='col-md-12 text-center'>
            <div className='card'>
                <div className='card-body'>
                    {cargando ? 
                    <>
                        <Dimmer active inverted className="mt-5 mb-5">
                          <Loader
                            size="big"
                            inverted
                            content="Validando autenticación con Clave Única, espere un momento"
                          />
                        </Dimmer>
                        
                    </>
                   
                    : !error ?<></> : 
                    <>
                        <div className="alert alert-danger" role="alert">
                            <strong>Atención</strong>, Ha ocurrido un error al validar su clave única, uno de los parámetros recibidos no es correcto.
                        </div>
                    </>}
                </div>
            </div>
            
        </div>
    </div>
  )
}
